import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import "./css/App.css";
import "./css/components.scss";
import "./css/general.scss";
import "./css/Home.scss";
import "./css/CaseStudies.scss";
import "./css/components_v2.scss";

import 'aos/dist/aos.css';

import Footer from "./components/global/Footer";
import Navigation_V2 from "./components/global/Navigation_V2";
import Home_v3 from "./pages/Home_v3";

import Lenis from 'lenis';
import { useEffect } from 'react';
import { useReveal } from './components/global/UseReveal';


function App() {
  useEffect(() => {
    const lenis = new Lenis({ smoothWheel: true });
    const raf = (t) => { lenis.raf(t); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  useReveal('.reveal');

  return (
      <main>
        <Router basename="/Resume">
          <Navigation_V2 />
          <Routes>
            <Route path="/" element={<Home_v3 />} />
            {/* <Route path='/case-studies/alabama-ag' element={<AlabamaAg />} /> */}
            {/* <Route path="/case-studies/smart-fusion" element={<SmartFusion/>} /> */}
          </Routes>
          <Footer />
        </Router>
      </main>
  );
}

export default App;
